export default __webpack_public_path__ + "static/media/Custom.f2f86067.png";